import { Component, OnInit } from "@angular/core";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";
import { FailedRecommitOrder } from "../../models/failed-recommit-order.model";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: "pa-failed-recommits",
    templateUrl: "./failed-recommits.component.html",
    styleUrls: ["./failed-recommits.component.scss"],
    standalone: false
})
export class FailedRecommitsComponent implements OnInit {
  isLoading: boolean;
  dataExist = false;
  recordsSaved = false;
  errorMessage = "";

  failedRecommitOrders: FailedRecommitOrder[] = [];

  displayedColumns;

  dataSource: MatTableDataSource<FailedRecommitOrder> = new MatTableDataSource(
    []
  );

  constructor(
    private portalAdminService: PortalAdminService,
    private router: Router
  ) {}

  ngOnInit() {
    this.displayedColumns = [
      "reProcess",
      "email",
      "createDate",
      "accountName",
      "salesOrderNumber",
    ];

    this.isLoading = true;

    this.portalAdminService.getFailedRecommitOrders().subscribe(
      (failedOrders: FailedRecommitOrder[]) => {
        this.failedRecommitOrders = failedOrders;
        console.log(this.failedRecommitOrders);
        this.dataSource.data = this.failedRecommitOrders;
        this.dataExist = true;
        this.isLoading = false;
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;

        console.log(err);

        if (err.status === 400) {
          this.errorMessage = err.error;
        } else if (err.status === 403 || err.status === 401) {
          this.router.navigate(["/access-denied"]);
        } else {
          this.router.navigate(["/error"]);
        }
      }
    );
  }

  selectAll(event) {
    for (const i of this.failedRecommitOrders.keys()) {
      this.failedRecommitOrders[i].reProcess = event.checked;
      console.log("select all: ", event.checked);
    }
    console.log("failed: ", this.failedRecommitOrders);

    this.dataSource.data = this.failedRecommitOrders;
  }

  changed(event) {
    console.log("changed: ", event.checked);
    console.log("failed: ", this.failedRecommitOrders);
  }

  processData() {
    this.isLoading = true;

    if (this.failedRecommitOrders.length > 0) {
      this.portalAdminService
        .processFailedRecommitOrders(this.failedRecommitOrders)
        .subscribe(
          () => {
            this.recordsSaved = true;
            this.isLoading = false;
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;

            this.errorMessage = err.message;
            console.log(err);

            if (err.status === 403 || err.status === 401) {
              this.router.navigate(["/access-denied"]);
            } else {
              this.router.navigate(["/error"]);
            }
          }
        );
    }
  }
}
